import { render, staticRenderFns } from "./TablaModulosOferta.vue?vue&type=template&id=81afab9e"
import script from "./TablaModulosOferta.vue?vue&type=script&lang=js"
export * from "./TablaModulosOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports